import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../lib/api';

export interface TrendStat {
  current: number;
  previous: number;
  pct: number | null;
}

export interface ActivityItem {
  id: string;
  type: 'message_sent' | 'reply_received' | 'hit_logged' | 'contact_added';
  description: string;
  timestamp: string;
}

export interface DashboardStats {
  totalContacts: number;
  totalPressLists: number;
  messagesSentThisMonth: number;
  messagesSentAllTime: number;
  replyRate: number;
  bounceRate: number;
  totalHits: number;
  activeCampaigns: number;
  trends: {
    contacts: TrendStat;
    pressLists: TrendStat;
    messages: TrendStat;
    hits: TrendStat;
  };
  recentActivity: ActivityItem[];
}

export interface UserStat {
  id: string;
  name: string;
  email: string;
  messagesSent: number;
  repliesReceived: number;
  hitsLogged: number;
  activePressLists: number;
}

export interface ClientStat {
  id: string;
  name: string;
  messagesSent: number;
  repliesReceived: number;
  replyRate: number;
  coverageCount: number;
  activePressLists: number;
}

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard-stats'],
    queryFn: () => apiGet<DashboardStats>('/dashboard/stats'),
    refetchInterval: 60_000,
  });
}

export function useDashboardUserStats() {
  return useQuery({
    queryKey: ['dashboard-user-stats'],
    queryFn: () => apiGet<UserStat[]>('/dashboard/stats/users'),
    refetchInterval: 60_000,
  });
}

export function useDashboardClientStats() {
  return useQuery({
    queryKey: ['dashboard-client-stats'],
    queryFn: () => apiGet<ClientStat[]>('/dashboard/stats/clients'),
    refetchInterval: 60_000,
  });
}
